import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import icon from 'flarum/common/helpers/icon';
import humanTime from 'flarum/common/helpers/humanTime';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import classList from 'flarum/common/utils/classList';

export default class GroupApplicationNotification extends Notification {
  icon() {
    return 'fa-light fa-users';
  }

  // 覆盖 view 方法，不显示 avatar
  view(vnode) {
    const notification = this.attrs.notification;
    const href = this.href?.() ?? '';

    return (
      <Link
        className={classList('Notification', `Notification--${notification.contentType()}`, [!notification.isRead() && 'unread'])}
        href={href}
        external={href.includes('://')}
        onclick={this.markAsRead.bind(this)}
      >
        {/* 不显示 avatar */}
        {icon(this.icon?.(), { className: 'Notification-icon' })}
        <span className="Notification-title">
          <span className="Notification-content">{this.content?.()}</span>
          <span className="Notification-title-spring" />
          {humanTime(notification.createdAt())}
        </span>
        {!notification.isRead() && (
          <Button
            className="Notification-action Button Button--link"
            icon="fas fa-check"
            title={app.translator.trans('core.forum.notifications.mark_as_read_tooltip')}
            onclick={(e) => {
              e.preventDefault();
              e.stopPropagation();

              this.markAsRead();
            }}
          />
        )}
        <div className="Notification-excerpt">{this.excerpt?.()}</div>
      </Link>
    );
  }

  href() {
    // 优先从 subject 获取群组 ID（subject 已经通过 relationships 加载）
    const group = this.attrs.notification.subject();
    
    if (group && group.id) {
      // 使用 groupDetail 路由（驼峰命名，与 groups 扩展中注册的路由名称一致）
      return app.route('groupDetail', { id: group.id() });
    }
    
    // 如果 subject 不可用，从 content 中获取 group_id 作为后备
    const content = this.attrs.notification.content();
    if (content && content.group_id) {
      return app.route('groupDetail', { id: content.group_id });
    }
    
    return '';
  }

  content() {
    const notification = this.attrs.notification;
    const content = notification.content();
    const status = content?.status;
    const groupName = content?.group_name || '';
    
    if (status === 'approved') {
      return app.translator.trans('tf-cns-notifications.forum.notifications.group_application_approved_text', {
        group: groupName
      });
    } else if (status === 'rejected') {
      return app.translator.trans('tf-cns-notifications.forum.notifications.group_application_rejected_text', {
        group: groupName
      });
    }
    
    return '';
  }

  excerpt() {
    return null;
  }
}

